// 周边景区（枚举 + 展示函数；数据已走真实接口，见 src/api/stay.js）
// base_id 0 = 公共景区（不挂在某个旅居基地下），选项由 getStayBaseOptions + 前端追加值 0 组成
// level 等级下拉取字典 scenic_level 的 value（5A/4A…），见 views/stay/scenic/index.vue

export const SCENIC_STATUS = [
  { value: 1, label: '展示', tagType: 'success' },
  { value: 0, label: '下架', tagType: 'info' }
]

export function scenicStatusText(status) {
  const item = SCENIC_STATUS.find(s => s.value === status)
  return item ? item.label : String(status)
}

export function scenicStatusTagType(status) {
  const item = SCENIC_STATUS.find(s => s.value === status)
  return item ? item.tagType : 'info'
}

// 门票展示：0 = 免费
export function ticketText(price) {
  const n = Number(price) || 0
  return n > 0 ? `¥${n}/人` : '免费'
}
